import React, { useState, useEffect } from 'react';
import { MenuItem, FormControl, Select, Card, CardContent } from "@material-ui/core";
import './App.css';
import InfoBox from "./InfoBox";
import Map from "./Map";
import Table from "./Table";
import {sortData, prettyPrintStat} from "./util";
import LineGraph from "./LineGraph";
import "leaflet/dist/leaflet.css";

function App() {
  // STATE = how we define a variable in React
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState('worldwide');
  const [countryInfo, setCountryInfo] = useState([]);
  const [tableData, setTabledata] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 33.589886, lng: -7.603869 });
  const [mapZoom,setMapZoom] = useState(2);
  const [mapCountries,setMapCountries] = useState([]);
  const [casesType, setCasesType] = useState("cases");

  useEffect(() => {
    fetch("https://disease.sh/v3/covid-19/all")
    .then((response) => response.json())
    .then((data) => {
      setCountryInfo(data);
    })
  }, []) 
  
  //useEffect = Runs a piece of code based on a given condition
  useEffect ( () => {
    // async -> send a request, wait for it, do something with the info
    const getCountriesData = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries")
      .then((response) => response.json() )
      .then((data) => {
        const countries = data.map((country) => (
          {
            name: country.country,
            value: country.countryInfo.iso3
          }
        ));
        const sortedData = sortData(data);
        setTabledata(sortedData);
        setMapCountries(data);
        setCountries(countries);
      });
    };
    getCountriesData();
  }, []);

  const onCountryChange = async (event) => {
    const countryCode = event.target.value;
    setCountry(countryCode);

    const url = countryCode === 'worldwide' ? 'https://disease.sh/v3/covid-19/all' : `https://disease.sh/v3/covid-19/countries/${countryCode}` ;
    await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      setCountry(countryCode);
      setCountryInfo(data);

      setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
      setMapZoom(4);
    });
  };


  return (
    <div className="app">

      <div className="app__left">
        {/* Header => title + select input drop down */}
        <div className="app__header">
          <h1>COVID-19 TRACKER</h1>
          <FormControl className="app__dropdown">
            <Select variant="outlined" value={country} onChange={onCountryChange} >
            <MenuItem value="worldwide">Worldwide</MenuItem>

              {/* Loop through all the countries and show them in a drop down */}
              {
                countries.map( (country) => (
                  <MenuItem value={country.value}>{country.name}</MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </div>
      
        {/* InfoBoxs => 3 InfoBoxe */}

        <div className="app__stats">
              <InfoBox 
                isRed
                active={casesType === "cases"}
                onClick={(e) => setCasesType("cases")}
                title="Covid Cases" 
                total={prettyPrintStat(countryInfo.cases)} 
                cases={prettyPrintStat(countryInfo.todayCases)}/>
              <InfoBox 
                active={casesType === "recovered"}
                onClick={(e) => setCasesType("recovered")}
                title="Recovered" 
                total={prettyPrintStat(countryInfo.recovered)} 
                cases={prettyPrintStat(countryInfo.todayRecovered)}/>
              <InfoBox 
                isBlack
                active={casesType === "deaths"}
                onClick={(e) => setCasesType("deaths")}
                title="Deaths" 
                total={prettyPrintStat(countryInfo.deaths)} 
                cases={prettyPrintStat(countryInfo.todayDeaths)}/>
        </div>
        
        {/* Map */}
        <Map casesType={casesType} countries={mapCountries} center={mapCenter} zoom={mapZoom} />

      </div>

      <Card className="app__right">
        <CardContent>
          <h3>Live Cases by Country</h3>
          {/* Table */}
          <Table countries={tableData}/>
          {/* Graph */}
          <h3 className="app__graphTitle">Worldwide new {casesType}</h3>
          <LineGraph className="app__graph" casesType={casesType} />
          
        </CardContent>
      </Card>
      <h4>-{">"} SALHAOUI Mohamed -{">"}</h4>
    </div>
  );
}

export default App;
